import React from "react";
import {
  Box,
  Card,
  Typography,
  Avatar,
  Chip,
} from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import lock from "../../assets/lock.png";
import readyforpickup from "../../assets/readyforpickup.png";
import box from "../../assets/box.png";
import amazon from "../../assets/amazon.png";
import claimarrow from "../../assets/claimarrow.png";
export default function ProductSummary() {
  return (
    <Box sx={{ p: 2, background: "#F5F7F9", minHeight: "100vh" }}>
      {/* Header */}
      <Card
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          borderRadius: "20px",
          background: "#EEF6F3",
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
  <img src={box} alt="Ready for Pickup" style={{ width: 34, height: 34,  }} />
          <Box>
            <Typography
              sx={{
                color: "#718198",
                fontSize: 14,
                fontWeight: 400,
              }}
            >
              Products
            </Typography>

            <Typography
              sx={{
                fontWeight: 700,
                fontSize:   14,
                color: "#384F6F",
              }}
            >
              02
              <Typography
                component="span"
                sx={{
                  ml: 1,
                  fontWeight: 600,
                  fontSize: 12,
                  color: "#384F6F",
                }}
              >
                (01 Physical . 01 Digital)
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Card>

      {/* Physical Product */}
      <Card
        sx={{
          borderRadius: "30px",
          p: 3,
          mb: 3,
          boxShadow: "0px 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Box display="flex" alignItems="center">
          <Box
            component="img"
            src="https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/BGlessMVs/Kit_Kat_Rs_25.png"
            alt="snickers"
            sx={{
              width: 71,
              height: 71,
              objectFit: "contain",
              mr: 3,
            }}
          />

          <Box flex={1}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#384F6F",
              }}
            >
              Snickers Chocolate
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mt={1} justifyContent="space-between">


           
            <Typography
              sx={{
                fontSize: 14,
                color: "#718198",
                fontWeight: 500,
               
              }}
            >
              1 Items
            </Typography>
                    <Typography
            sx={{
              color: "#00B177",
              fontWeight: 700,
              fontSize: 16,
            }}
          >
            ₹20.00
          </Typography>

 </Box>

            <Box
              display="flex"
              alignItems="center"
              mt={1}
            >
         <img src={readyforpickup} alt="Ready for Pickup" style={{ width: 14, height: 14,marginRight:"5px" }} />
              <Typography
                sx={{
                  color: "#718198",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                Ready for Pickup
              </Typography>
            </Box>
          </Box>

  
        </Box>
      </Card>

      {/* Digital Product */}
      <Card
        sx={{
          borderRadius: "30px",
          overflow: "hidden",
          boxShadow: "0px 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Box p={3} pb={2}>
          <Box display="flex" alignItems="center">
           <img src={amazon} alt="Amazon" style={{ width: 65, height: 48, marginRight: "20px" }} />

            <Box flex={1}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                mb={1}
              >
             <Box backgroundColor="#F2F0FB" borderRadius="4px" p={0.2}  sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 68,
               
              }}>
                <p style={{ color: "#8658DF" ,fontFamily:"Roboto",fontSize:12,fontWeight:700,margin:"0" ,   
                }}>Digital</p>

             </Box>

           
           
           <img src={lock} alt="Lock" style={{ width: 30, height: 30 }} />
           </Box>

           <img src={claimarrow} alt="Claim Arrow" style={{ width: 30, height: 30 }} />
           
              </Box>
<Box display="flex" alignItems="center" justifyContent="space-between">


              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#384F6F",
                }}
              >
                Myntra Gift Card
              </Typography>

                      <Typography
              sx={{
                color: "#00B177",
                fontWeight: 700,
                fontSize: 16 ,
              }}
            >
              Free
            </Typography>
</Box>
              <Typography
                sx={{
                  fontSize: 14,
                  color: "#718198",
                  fontWeight: 500,
                  mt: 1,
                }}
              >
                1 Items
              </Typography>
            </Box>

    
          </Box>
        </Box>

        <Box
          sx={{
            borderTop: "1px solid #D8D8D8",
            py: 2,
            textAlign: "center",
            background: "#FFF",
          }}
        >
          <Typography
            sx={{
              fontStyle: "italic",
              fontWeight: 700,
              color: "#384F6F",
              fontSize: 12,
            }}
          >
            Digital Item Unlocks After Physical Pickup
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}